var $ = jQuery.noConflict();
var is_mobile = false;
var columnToggle = true;

$(document).ready(function(){

  //SCROLLING FUNCTIONS
  $(window).scroll(function(){
    var scrollTop = $(window).scrollTop();
    // console.log(scrollTop);


    if(scrollTop > 0){
      $('#site-navigation').addClass('condensed');
        $('#scroll-suggest').addClass('scrolled');
    }else{
      $('#site-navigation').removeClass('condensed');
        $('#scroll-suggest').removeClass('scrolled');
    }

  });


  // NAV FUNCTIONALITY
  $('.menu-ham').click(function(){
    $('.mobile-dropdown').toggleClass('active');
  });
  $('.search-button').click(function(){
    $('#site-navigation').toggleClass('searching');
  });

  //SCHOLARS LANDING
  if($('body').hasClass('page-template-template-scholars')){
    window.onpopstate=function(){
      console.log('popstate');
      console.log(window.location.hash);
      var year = window.location.hash.substring(1);
      var hash = window.location.hash;
      if(year == ''){
        hash = jQuery('.scholar-nav a:nth-child(1)').attr('href');
        year = jQuery('.scholar-nav a:nth-child(1)').attr('href').substring(1);
      }
      if(year == 'all'){
				year = '';
			}


			jQuery('.scholar-nav a').removeClass('active');
			jQuery('[href="' + hash + '"]').addClass('active');
			jQuery('.scholars-holder-container').fadeIn().css('display', 'flex');

			jQuery.ajax({
				url: ajaxurl,
				data: {
					action: 'do_ajax',
					fn: 'get_scholars',
					year: year
				},
				success: function success(data) {
					if (data !== null) {
						// console.log(data);
						if(year == ''){
							jQuery('.scholars h1 span').html('All');
							jQuery('.scholars h5').hide();
						}else{
							jQuery('.scholars h1 span').html(year);
							jQuery('.scholars h5 span').html(year);
							jQuery('.scholars h5').show();
						}
						jQuery('.scholars-container').html(data);
						setTimeout(function(){
							jQuery('.scholars-holder-container').fadeOut();
						},300);


					}
				},
				complete: function complete() {},
				error: function error(errorThrown) {
					console.log(errorThrown);
				}
			});
    }



  }

  // IMPACT PAGE ANIMATIONS
  $('.statistic-bar').each(function() {
      let percent = $(this).attr('percent');
      $(this).children().children('.statistic-bar-sizer').css('width', percent+'%');
  });

  $('.statistic-pie-border').each(function() {
      let percent = $(this).attr('percent');
      let offset = Math.floor((percent / 100) * 496) + 496;
      $(this).children('.border-ellipse').css('stroke-dashoffset', offset);
  });



  if($('body').hasClass('page')){
    $('.page-nav-link a').click(function(){
      var $this = $(this);
      var scrollPos = $('.page-content-type[key="' + $this.attr('key') + '"]').offset().top - 70;

      $('html, body').animate({
        scrollTop: scrollPos + 'px',

      }, 500);
    });
  }



  //Home slick
  $('#hero-image').slick({
    infinite: true,
    fade: true,
    cssEase: 'linear',
    // autoplay: true,
    // autoplaySpeed: 3000,
    pauseOnHover: false,
    arrows: false,
    adaptiveHeight: false,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
  });

    var time = 3;
    var $bar,
        $slick,
        isPause,
        tick,
        percentTime;

    $slick =   $('#hero-image');


    $bar = $('.slider-progress .progress');

    $('#home-hero').on({
      mouseenter: function() {
        // isPause = true;
      },
      mouseleave: function() {
        isPause = false;
      }
    })

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      isPause = false;
      tick = setInterval(interval, 10);
    }

    function interval() {
      if(isPause === false) {
        percentTime += 1 / (time+0.1);
        $bar.css({
          width: percentTime+"%"
        });
        if(percentTime >= 100)
          {
            $slick.slick('slickNext');
            startProgressbar();
          }
      }
    }


    function resetProgressbar() {
      $bar.css({
       width: 0+'%'
      });
      clearTimeout(tick);
    }

    startProgressbar();



  //OTHER SLICK
  $('.pls-slick').each(function(){
    var $this = $(this);
    var slickID = $this.closest('section').attr('plsSlickId');
    if($(this).next().hasClass('pls-slick-desc')){
	      $this.slick({
        adaptiveHeight: false,
      });
    }else{
      if($(this).hasClass('scholar-highlight-slick')){
          $this.slick({
          adaptiveHeight: true,
          dots: true,
          arrows: false,
          autoplay: false,
          fade:true
        });
      }else{
        $this.slick({
          adaptiveHeight: false,
          dots: true,
          arrows: false,
          autoplay:true,
          fade:true
        });
      }

    }

  });

  //DESCRIPTION SLICKS
  $('.pls-slick-desc').each(function(){
    var $this = $(this);
    var slickID = $this.closest('section').attr('plsSlickId');
    var slickGallery = $this.closest('[plsSlickId = "' + slickID + '"]').find('.pls-slick');

    $this.slick({
      adaptiveHeight: false,
      dots: true,
      arrows: false,
      fade: true,
      touchMove: false,
      swipe: false,
      autoplay: true,
    });

    $this.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      slickGallery.slick('slickGoTo', nextSlide);
    });

    slickGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $this.slick('slickGoTo', nextSlide);
    });

  });


    // violator
    $('.violator-close').click(function() {
        $('.violator-container').addClass('dismissed');
    });

    if ( $('.violator-container') ) {
        document.cookie = "violator-dismissed=true;path=/";
    }


$(".page-block").each(function(i,x){
	var rgbs = getRGB($(this).css('background-color'));
		//console.log(rgbs.red);
	var luma = 0.2126 * rgbs.red + 0.7152 * rgbs.green + 0.0722 * rgbs.blue; // per ITU-R BT.709
	if(luma < 190 && luma > 0){
		$(this).addClass('darkBg');
	}else{
		$(this).addClass('lightBg');
	}
	console.log(luma + $(this).parent().attr('key'));

})



  //page scroll to content
  $('#scroll-to-read').click(function(){
    var storyTop = $('.story-container').offset().top - 60;
    $('html,body').animate({
      scrollTop: storyTop,
    }, 1000);
  });


  //responsive iframes
  $('iframe').each(function(){
    $(this).wrap('<div class="iframe-container"></div>');
  });

});

function getRGB(str){
  var match = str.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);
  return match ? {
    red: match[1],
    green: match[2],
    blue: match[3]
  } : {};
}



// WEBPACK FOOTER //
// ./js/script.js